
import React from 'react';
import isNil from 'lodash/isNil';

import SelectPricelistTypeDisabled from './SelectPricelistTypeDisabled.view';
import SelectPricelistTypeEnabled from './SelectPricelistTypeEnabled.view';

const SelectPricelistType = ({
    onSetPricelistType,
    pricelistType
}) => {

    const [type, setType] = React.useState(pricelistType);
    const disabled = !isNil(pricelistType);

    React.useEffect(() => {
        setType(pricelistType);
    }, [pricelistType]);

    const handleContinueClick = () => {
        if (onSetPricelistType) {
            onSetPricelistType(type);
        }
    }

    const handleChangeTypeClick = () => {
        setType(null);
        if (onSetPricelistType) {
            onSetPricelistType(null);
        }
    }

    const handleTypeChange = (e, option) => {
        setType(option.key);
    };

    return (
        <>
            {disabled &&
                <SelectPricelistTypeDisabled
                    onChangeClick={handleChangeTypeClick}
                    pricelistType={pricelistType}
                />
            }
            {!disabled &&
                <SelectPricelistTypeEnabled
                    pricelistType={type}
                    onContinueClick={handleContinueClick}
                    onTypeChange={handleTypeChange}
                />}
        </>
    );
}

export default SelectPricelistType;
